import React, { useEffect, useState } from 'react';

import {
  ConsentValue,
  applyGtagConsent,
  applyRudderStackConsent,
  getConsentCookie,
  hasGlobalPrivacyControl,
  isMarketingAllowed,
  onShowConsentBanner,
  setConsentCookie,
} from '../lib/consent';
import { clearGa4UserId } from '../lib/ga4User';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => {
      if (!hasGlobalPrivacyControl()) setVisible(true);
    };
    if (!getConsentCookie()) show();
    return onShowConsentBanner(show);
  }, []);

  function handleChoice(value: ConsentValue) {
    setConsentCookie(value);
    applyRudderStackConsent(value);
    // gtag keeps user_id for the page, and cookieless pings would still send it.
    if (!isMarketingAllowed(value)) clearGa4UserId();
    applyGtagConsent(value);
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-5 left-5 z-[1000000] w-[320px] p-4 bg-white rounded">
      <p className="text-black m-0">
        We use{' '}
        <a href="https://tokentax.co/cookie-policy" className="underline text-black">
          cookies
        </a>{' '}
        to improve your experience.
      </p>
      <div className="flex gap-2 mt-3">
        <button
          onClick={() => handleChoice('accepted')}
          className="flex-1 py-2 px-3 font-medium text-white bg-light-brand border-none rounded-md cursor-pointer"
        >
          Accept All
        </button>
        <button
          onClick={() => handleChoice('rejected')}
          className="flex-1 py-2 px-3 font-medium text-white bg-black border-none rounded-md cursor-pointer"
        >
          Reject
        </button>
      </div>
    </div>
  );
}
